"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLogger = void 0;
function logFn(isEnabled, type, color, textColor) {
    return function () {
        var messages = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            messages[_i] = arguments[_i];
        }
        if (isEnabled) {
            console.log.apply(console, __spreadArrays(["%c " + type.toUpperCase() + " ",
                "background: " + color + "; color: " + (textColor !== null && textColor !== void 0 ? textColor : '#fff')], messages));
        }
    };
}
function createLogger(isEnabled) {
    return {
        info: logFn(isEnabled, 'info', '#2196f3'),
        warn: logFn(isEnabled, 'warn', '#FF9800'),
        error: logFn(isEnabled, 'error', '#f44336'),
        comm: logFn(isEnabled, 'comm', '#DBD64E'),
        comm_recv: logFn(isEnabled, 'comm', '#DBD64E', '#000'),
        module: logFn(isEnabled, 'module', '#DB14C7'),
    };
}
exports.createLogger = createLogger;
//# sourceMappingURL=Logger.js.map